export const pricing = {
  "breadcrumb": "Ceny",
  "title": "Proste i elastyczne stawki",
  "subtitle": "Jedna prowizja 5%, płacona przez kogo chcesz.",
  "whoPays": {
    "title": "Kto płaci opłaty?",
    "traveler": {
      "label": "Opcja 1: Podróżny płaci (Zalecane)",
      "description": "Otrzymujesz 100% swojej ceny. Podróżny dodaje 5% opłaty serwisowej.",
      "badge": "Domyślnie"
    },
    "host": {
      "label": "Opcja 2: Gospodarz płaci (Pro)",
      "description": "Ty płacisz 5%. Cena wyświetlana niższa dla podróżnego, idealne dla firm.",
      "badge": "Opcja Pro"
    }
  },
  "guarantee": "Pełna przejrzystość gwarantowana",
  "perYear": "/rok",
  "choose": "Wybierz",
  "popular": "Najpopularniejszy",
  "plans": {
    "traveler": {
      "name": "Podróżny",
      "description": "Aby odkrywać świat tanim kosztem",
      "price": "5%",
      "period": "prowizji",
      "features": [
        "Dostęp do wszystkich domów",
        "Obniżone opłaty serwisowe (5%)",
        "Ubezpieczenie w cenie",
        "Wsparcie 7/7",
        "Brak ukrytych opłat"
      ]
    },
    "host": {
      "name": "Gospodarz",
      "description": "Aby wynajmować bez opłat i wymieniać się",
      "price": "0%",
      "period": "prowizji",
      "features": [
        "0% prowizji od Twoich dochodów",
        "Dostęp do darmowych wymian między gospodarzami",
        "Dostępna odznaka \"Uczciwa Cena\"",
        "Zwiększona widoczność",
        "Priorytetowe wsparcie"
      ]
    }
  },
  "fairPrice": {
    "title": "Program Uczciwa Cena",
    "description": "Graj uczciwie, zarabiaj więcej.",
    "benefit1": "Widoczna odznaka \"Uczciwa Cena\"",
    "benefit2": "Priorytet w wynikach",
    "benefit3": "Bonus punktów wymiany",
    "condition": "Zaproponuj stawkę co najmniej 10% tańszą niż na innych platformach."
  },
  "taxAdvantage": {
    "title": "Korzyść podatkowa i Pro",
    "text": "Opłaty 5% mogą być odliczone od Twoich kosztów, jeśli jesteś firmą. Model 0% upraszcza księgowość osób fizycznych. Skonsultuj się z księgowym."
  },
  "hostExchange": {
    "title": "System Wymiany Gospodarza",
    "description": "Wymień swoje zarobione noce na darmowe pobyty.",
    "free": "Darmowe (0€)",
    "community": "Zarezerwowane dla zweryfikowanych członków"
  },
  "comparison": {
    "title": "Dlaczego to lepsze?",
    "subtitle": "Porównaj i zobacz różnicę",
    "features": "Opłaty",
    "airbnb": "Airbnb / Booking",
    "traveltrok": "DONKEY TRAVEL",
    "hostFees": "Opłaty Gospodarza",
    "travelerFees": "Opłaty Podróżnego",
    "exchange": "Darmowa Wymiana"
  },
  "testimonials": {
    "title": "Co mówią nasi członkowie",
    "subtitle": "Dołącz do społeczności, która zmienia zasady",
    "badge": "Opinie",
    "exchanges": "wymiany",
    "saved": "zaoszczędzone",
    "verifiedMembers": "+15 000 członków",
    "completedExchanges": "+50 000 podróży",
    "totalSaved": "0% prowizji"
  },
  "faq": {
    "title": "Częste pytania",
    "subtitle": "Wszystko, co musisz wiedzieć o naszych stawkach",
    "q1": {
      "question": "Czy mogę zmienić plan w dowolnym momencie?",
      "answer": "Tak, możesz przejść na wyższy plan w każdej chwili. Różnica zostanie obliczona proporcjonalnie do obecnej subskrypcji."
    },
    "q2": {
      "question": "Czy są dodatkowe opłaty?",
      "answer": "Nie, żadnych ukrytych opłat. Wyświetlona cena to ostateczna cena, którą płacisz rocznie. Wymiany są następnie całkowicie darmowe."
    },
    "q3": {
      "question": "Co się dzieje, jeśli nie jestem zadowolony?",
      "answer": "Oferujemy gwarancję satysfakcji lub zwrotu pieniędzy przez 30 dni. Jeśli nie jesteś zadowolony, zwracamy Ci pełną kwotę."
    },
    "q4": {
      "question": "Jak działa fakturowanie?",
      "answer": "Jesteś fakturowany rocznie. Możesz płacić kartą bankową lub przelewem. Fakturowanie jest automatyczne i otrzymujesz fakturę e-mailem."
    },
    "q5": {
      "question": "Czy mogę anulować subskrypcję?",
      "answer": "Tak, możesz anulować w dowolnym momencie. Twoja subskrypcja pozostanie aktywna do końca opłaconego okresu."
    }
  },
  "cta": {
    "title": "Gotowy, by zacząć przygodę?",
    "subtitle": "Dołącz do tysięcy właścicieli, którzy podróżują za darmo",
    "createAccount": "Utwórz moje konto",
    "exploreDestinations": "Przeglądaj miejsca docelowe"
  },
  "signup": {
    "title": "Utwórz swoje konto",
    "subtitle": "Dołącz do naszej społeczności właścicieli",
    "firstName": "Imię",
    "lastName": "Nazwisko",
    "email": "Email",
    "phone": "Telefon",
    "country": "Kraj",
    "selectCountry": "Wybierz swój kraj",
    "plan": "Pakiet",
    "selectPlan": "Wybierz swój plan",
    "propertyType": "Typ nieruchomości",
    "selectPropertyType": "Wybierz typ nieruchomości",
    "terms": "Akceptuję warunki użytkowania i politykę prywatności",
    "submit": "Utwórz moje konto",
    "success": "Konto utworzone pomyślnie!",
    "error": "Wystąpił błąd. Spróbuj ponownie.",
    "securityNote": "Twoje dane są bezpieczne i nigdy nie będą udostępniane",
    "house": "Dom",
    "apartment": "Mieszkanie",
    "villa": "Willa",
    "loft": "Loft",
    "other": "Inne"
  },
  "signupSection": {
    "title": "Dołącz do DONKEY TRAVEL już dziś",
    "subtitle": "Utwórz konto w kilka minut i zacznij wymieniać swoje mieszkanie z właścicielami z całego świata.",
    "verifiedMembers": "Zweryfikowani członkowie",
    "verifiedMembersDesc": "Wszyscy nasi członkowie są zweryfikowanymi gospodarzami Airbnb dla bezpiecznych wymian.",
    "guaranteedSavings": "Gwarantowane oszczędności",
    "guaranteedSavingsDesc": "Nasi członkowie oszczędzają średnio 3 500€ rocznie na kosztach zakwaterowania.",
    "globalNetwork": "Globalna sieć",
    "globalNetworkDesc": "Uzyskaj dostęp do ponad 15 000 domów w 85 krajach na całym świecie.",
    "responsiveSupport": "Reaktywne wsparcie",
    "responsiveSupportDesc": "Nasz zespół jest dostępny 7 dni w tygodniu, aby towarzyszyć Ci w wymianach."
  },
  "testimonialItems": {
    "sophie": "Dzięki DONKEY TRAVEL odwiedziłam Barcelonę, Rzym i Amsterdam bez płacenia za nocleg. Społeczność jest reaktywna, a rozmowy o wymianie są proste.",
    "thomas": "Dołączyłem do oferty startowej 2026: -50% w pierwszym roku. Cena jest gwarantowana dożywotnio dla pierwszych 1000, i wymieniam się w całej Europie.",
    "marie": "W końcu zrobiłam moją pierwszą wymianę w Europie, i wszystko poszło gładko od pierwszej wiadomości do przyjazdu. Weryfikacja profili naprawdę pomaga.",
    "pierre": "Dla naszych domów pulpit nawigacyjny oszczędza nam czas: ogłoszenia, wiadomości i dostępność są jasne i łatwe do zarządzania."
  }
};
